import React, { useState } from "react";
import { FaUniversity, FaGraduationCap, FaMapMarkerAlt } from "react-icons/fa";
import UserProfileModal from "./UserEditProfileModal";

const UserProfile = ({ token }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("USER_INFO"));
  console.log('user details',JSON.stringify(userDetails))

  const handleEditProfileClick = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };


  return (
    <div className="pt-16 px-5 bg-gray-100 md:flex justify-center  h-screen">
      <div className="py-10 px-5 flex flex-col items-center bg-white h-fit w-full md:w-1/2 rounded-lg shadow-md">
        <div className=" rounded-full">
          <img
            src={userDetails.profileImageUrl}
            alt="User Profile"
            className="rounded-full w-32 h-32"
          />
        </div>
        <h1 className="text-3xl font-semibold py-2">{userDetails.name}</h1>
        <p className="text-gray-600 pb-10">{userDetails.about}</p>

        <div className="space-y-2">
          {userDetails.school && (
            <div className="flex items-center">
              <FaUniversity className="text-blue-500 text-lg mr-2" />
              <span className="text-sm">{userDetails.school}</span>
            </div>
          )}

          {userDetails.education && (
            <div className="flex items-center">
              <FaGraduationCap className="text-blue-500 text-lg mr-2" />
              <span className="text-sm">{userDetails.education}</span>
            </div>
          )}

          {userDetails.location && (
            <div className="flex items-center">
              <FaMapMarkerAlt className="text-blue-500 text-lg mr-2" />
              <span className="text-sm">{userDetails.location}</span>
            </div>
          )}
        </div>

        <div className="mt-5">
          <button
            className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none"
            onClick={handleEditProfileClick}
          >
            Edit Profile
          </button>
        </div>

        {/* Edit Profile Modal */}
        {isModalOpen && (
          <UserProfileModal
            userDetails={userDetails}
            closeModal={closeModal}
            token={token}
          />
        )}
      </div>
    </div>
  );
};

export default UserProfile;
